// public/site-config.js 在 HTML 头部按域名选择配置，供页面和收录策略共用。
const site = window.__SITE_CONFIG__
if (!site) {
  throw new Error('网站配置未加载：请检查 runtime-env.js 和 site-config.js')
}
export default site
